<style scoped>
::v-deep .el-progress__text{
    font-size: 10px!important;
}
.demo-1-hero {
    display: grid;
    align-items: center;
    align-content: center;
    min-height: 0px;
    text-align: center;
}

.contactusblockpair-1 {
    display: block;
   
}

/*.accordion-button:not(.collapsed) {
    color: #484848;
    background-color: #e7f1ff00;
    box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}*/

.accordion-button {
    padding: 5px 15px;
    font-size: 1rem;
    font-weight: 800;
    color: var(--bs-accordion-active-color);
}

.accordion-body {
    padding: 10px 15px;
    font-size: .9rem;
}

.accordion-body p {
    border-bottom: 1px #adb5bd dashed;
}

.accordion {
    --bs-accordion-bg: #ffffff4a;
}

.title_1 {
    color: #ce0c05
}

.res .nav .nav-link {
    color: var(--bs-gray-700);
}

.res .nav .active {
    color: var(--bs-link-color);
    background-color: #fff0;
    border-bottom-color: #eef0f4;
}
::v-deep .el-select__wrapper.is-filterable {
    height: 36px!important;
}
::v-deep .el-message--error{
    z-index: 9999!important;
}
::v-deep .el-upload,::v-deep .el-upload-dragger{
    height:100%;
    
}
::v-deep .el-upload-dragger{
    padding: 20px;
}
.el-table >>> th.el-table__cell {
    background-color: #F2F2F7;
}
</style>

<template>

   
<section class="demo-1-hero ">
    
    <div class="container">
        <div class="row vcenter">
            <div class="col-lg-12">
                <div class="hero-content">
                    <div  data-delay="40" style="font-size: 28px;line-height: normal;">
                        <!-- ADVANCED Reviser(<span class="title_1">A</span>I-<span class="title_1">D</span>riven de<span class="title_1">V</span>elopment and <span class="title_1">A</span>ssessme<span class="title_1">N</span>t of
health<span class="title_1">C</span>are guid<span class="title_1">E</span>lines and stan<span class="title_1">D</span>ards) -->
                        <span style="font-size: 36px;font-weight: bold;">ADVANCED Writer</span> <span style="font-size: 28px;font-weight: normal;">-- An AI agent designed to assist in the standardization of manuscript reporting and facilitate rapid evaluation</span>
                    </div>
                    <p class="mt20"  data-delay="600" style="font-size: 18px;">
                        妙笔 -- 帮助作者撰写更加完整、规范和清晰的文章，协助编辑和审稿人快速确定文章的报告质量，指出报告存在的问题
                    </p>                        
                       
                </div>
            </div>
        </div>
    </div>
</section> 

<section class="sec-pad position-relative" style="margin-bottom: 50px;padding-bottom: 30px;">
    
    <div class="container index-up">
        <div class="row">
            <div class="col-lg-12">
                <div class="contactusblockpair-1 shadow roundimg">
                    <div class="formblockz" style="background: white;">
                        <div class="form-block rundalform">
                            <el-upload
                                class="upload-demo"
                                style="height:150px"
                                drag
                               
                                :on-change="handleChange"
                                :on-exceed="handleExceed"
                                :show-file-list = false	
                                accept=".docx,.pdf" 
                                
                            >
                                <img 
                                    v-if="fileUp && fileUp.type === 'application/pdf'" 
                                    src="/statics/images/pdf@2x.png" 
                                    style="width:58px;height:58px;margin-top: 10px;"
                                    
                                />
                                <img 
                                    v-else-if="fileUp && fileUp.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" 
                                    src="/statics/images/doc@2x.png" 
                                    style="width:58px;height:58px;margin-top: 10px;"
                                    
                                />
                                <img 
                                    v-else 
                                    src="/statics/images/upload@2x.png" 
                                    style="width:78px;height:66px"
                                    
                                />
                                
                                <div v-if="fileUp" class="el-upload__text">  {{ fileUp.name }}</div>
                                <div v-else class="el-upload__text">
                                    Drop file here or <em>click to upload</em>
                                    <div style="font-size: 12px;color:#8C919C">support WORD and PDF</div>
                                </div>
                               
                            </el-upload>



                            
                            <ul id="filelist"></ul>
                         
                            
                        </div>
                        <div class="" style="margin-top: 20px;text-align: left;display: flex; justify-content: space-between; align-items: center;">
                                   <span style="font-size: 14px;color:#515862;margin-right:10px">Checklist:</span>
                                   <el-select
                                       v-model="promptsValue"
                                       filterable
                                       placeholder="Please select a checklist"
                                       style="width: 314px"
                                   >
                                       <el-option
                                       v-for="item in promptsOptions"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value"
                                       />
                                   </el-select>
                                   <!-- <el-select
                                       v-model="llmValue"
                                       filterable
                                       placeholder="请选择模型"
                                       style="width: 240px;margin-left:20px"

                                   >
                                       <el-option
                                       v-for="item in llmOptions"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value"
                                       />

                                   </el-select> -->
                                   <el-button class="ml-3" type="success" @click="submitUpload" style="background: #3E959B;
border-radius: 20px 20px 20px 20px;right:40px;height:36px;margin-left:auto;width:370px" >
                                        Run
                                    </el-button>
                               </div>
                    </div>
                    <div class="infoblockz sw-bg-3-wave" style=" background: white;margin-top:25px">
                        <div v-if="tableData.length == 0" class="contactinfodivv"><img src="/statics/images/empty@2x.png" style="height:220px;width:240px"/></div>
                        <div v-else class="contactinfodivv" style="display: flex; flex-wrap: wrap; width: 100%;">
                            <div style="margin-left:auto;color:#04A3AE;font-size: 14px;cursor: pointer;margin-bottom: 5px;" @click="moreClick">more<img src="/statics/images/more.png" style="width:16px;height:16px;top:-1px;position: relative;"/></div>
                            <div class="con-block-sw-div" style="min-height: 100px;width:100%">
                                <div>
                                    <el-table :data="tableData" style="width: 100%">
                                        <el-table-column prop="filename" label="File Name" ></el-table-column>
                                        <el-table-column prop="promptInfo.name" label="Checklist" width="120"></el-table-column>
                                        <el-table-column label="Uploaded time" width="180">
                                            <template #default="scope">
                                                <div style="display: flex; ">
                                            
                                                    <span>{{ new Date(scope.row.createdAt).toLocaleString() }}</span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Finished time" width="180">
                                            <template #default="scope">
                                                <div style="display: flex; ">
                                            
                                                    <span>{{ new Date(scope.row.updatedAt).toLocaleString() }}</span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Status" width="120">
                                            <template #default="scope">
                                                <div style="display: flex; ">
                                                    <el-progress v-if="state.progressData[scope.row.id]" type="circle" width="45" :percentage="state.progressData[scope.row.id]" :stroke-width="6"/>
                                                    <span v-else-if="scope.row.status === '4'"> Pending</span>
                                                    <span v-else-if="scope.row.status === '1'"> Pending</span>
                                                    <span v-else-if="scope.row.status === '2'"> Completed</span>
                                                    <span v-else>Error</span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Operation" width="120">
                                            <template #default="scope">
                                                <!-- <el-button size="small" @click="handleDown(scope.$index, scope.row)">
                                                下载
                                                </el-button> -->
                                                <el-button link size="small" :style="{
                                                    border: 0, 
                                                    color: scope.row.status === '2' ? '#04A3AE' : '#B0B0B0', 
                                                    cursor: scope.row.status === '2' ? 'pointer' : 'not-allowed'
                                                }"  :disabled="scope.row.status !== '2'" @click="gotoDetail(scope.$index, scope.row)">
                                                Detail
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!-- <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="total"
                                    :page-size="pageSize"
                                    :current-page="currentPage"
                                    @current-change="handleCurrentChange"
                                    style="margin-top: 10px;float: right;"
                                    ></el-pagination> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

</template>
<script lang="ts">
  export default {
    name: 'CheckListView',
  };
  
  </script>
  <script setup lang="ts">
  import { ref,toRaw,reactive, onMounted, watch, onBeforeUnmount} from 'vue';
  import { useRouter } from 'vue-router';
  import { genFileId ,ElMessage,ElLoading} from 'element-plus';
  import type { UploadFile, UploadInstance, UploadProps, UploadRawFile,ElProgress } from 'element-plus';
  import { checkListGetall, getProgress, judgeChecklist} from "../api/modules/api.checklist";
  import {getList,create,downloadExcel} from "../api/modules/api.upload";
  import {authIsLogin} from '../api/modules/api.auth.js';
  import dbUtils from '../libs/util.strotage.js'
  const promptsValue = ref('')
  const llmValue = ref('')
  const promptsOptions = ref([])
  const llmOptions = ref([{value:'gpt-4o',label:'gpt-4o'},{value:'gpt-4-0125-preview',label:'gpt-4-0125-preview'},{value:'gpt-4-1106-preview',label:'gpt-4-1106-preview'},{value:'gpt-3.5-turbo-0125',label:'gpt-3.5-turbo-0125'},
  {value:'gpt-3.5-turbo-1106',label:'gpt-3.5-turbo-1106'},{value:'claude-3-opus-20240229',label:'claude-3-opus-20240229'},
  {value:'claude-3-sonnet-20240229',label:'claude-3-sonnet-20240229'}
  ])

    const tableData = ref([]);
    const total = ref(0);
    const pageSize = ref(5);
    const currentPage = ref(1);
    const router = useRouter();
    const userInfo = dbUtils.get('FrontuserInfo')
   
    let uploadsIds = dbUtils.get("UploadsIds")
    const ifLogin = ()=>{
        authIsLogin().then(res => {
            console.log(res)
            if(!res.data){
                dbUtils.remove("FrontuserInfo") //去掉登录信息
            }
            fetchData();
        })
    }
    
    const fetchData = async (page = 1) => {
        try {
            

            let p = {
                pagination:{"current":page,
                            "pageSize":pageSize.value
                }
            }
            if(!userInfo){
                p["params"] = {}
                p["params"]["id"] = [null]
                if(uploadsIds){
                    p["params"]["id"] = uploadsIds.slice(0,10) //最多10个
                }
                

            }
            getList(p).then(res => {
                state.loading.spinning = false
                let datas = res.data.result
                
                tableData.value = datas
                total.value = res.data.total
                state.query.pagination.current = res.data.current
                state.query.pagination.pageSize = res.data.pageSize
            }).catch(err => {
                state.loading.spinning = false
                console.log(err)
            })
        
       
        } catch (error) {
        ElMessage.error('获取数据失败');
        }
    };
    const get_progress = ()=>{
        getProgress().then(res => {
            const keys1 = Object.keys(state.progressData);
            const keys2 = Object.keys(res.data);
            if(JSON.stringify(keys1) !== JSON.stringify(keys2)){
                fetchData(currentPage.value);
            }
            state.progressData = res.data
        })
    };
    const state = reactive({
      progressData:{},
      show: {
        add: false,
        edit: false,
        view: false
      },
      activeComponent: null,
      // 暂存更新数据
      updateData: {},
      // 暂存查看数据
      viewData: {},
      dataList: [],
      // 请求参数
      query: {
        params: {},
        pagination: {
          current: 1,
          pageSize: 5,
          total: 0,
          hideOnSinglePage: true,
        },
        sort: {
          columnKey: "createdAt",
          order: "ascend"
        }
      },
      // loading
      loading: {
        spinning: false,
        tip: '加载中'
      }
    })
    let timer
    let timer2
    const fileName = ref('')
    const upload = ref<UploadInstance>()
    const fileUp = ref()
    const handleExceed: UploadProps['onExceed'] = (files) => {
    upload.value!.clearFiles()
    const file = files[0] as UploadRawFile
    
    file.uid = genFileId()
    upload.value!.handleStart(file)
    fileName.value = file.name
    
  }
  const moreClick = ()=>{
     //router.push('/uploadsList'); // 使用 push 跳转
     //router.push({ name: 'Detail', params: { id: items.id } });
     const url = `/uploadsList`;
     window.open(url, '_blank');
  }
  const handleCurrentChange = (page) => {
      currentPage.value = page;
      fetchData(page);
    };

  const handleDown = (item,item2)=>{
    try {
        let p = {
            "id":item2.id,
            
        }
        downloadExcel(p).then(res => {
                 
        }).catch(err => {
           
            console.log(err)
            ElMessage.error('下载失败'+err.message);
        })
    
    
    } catch (error) {
        ElMessage.error('下载失败'+error.message);
    }

  }  
  const gotoDetail = (item, items)=>{
    //router.push({ name: 'Detail', params: { id: items.id } });
    const url = `/detail/${items.id}`;
    window.open(url, '_blank');
  }


  const handleSuccess = (uploadFile: UploadFile) => {
    console.log("fsadjisajdisajdias")
    console.log(uploadFile)
  }
  const handleChange = (uploadFile: UploadFile) => {
    if(uploadFile.status === 'ready'){
        return;
    }
  // 设置input框的值为上传文件的名称
    fileName.value = uploadFile.name
    console.log("the file is")
    console.log(uploadFile)
    console.log(uploadFile.name)
    

    fileUp.value = uploadFile.raw
    var data = new FormData();
    data.append("file", fileUp.value, fileName.value);
    
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading', 
    })
    judgeChecklist(data).then(res => {
       console.log(res);
       const categoryValue = res.data?.category;
        if (categoryValue) {
            console.log("Category exists:", categoryValue);
            
            promptsOptions.value.forEach((element) => {
                if (element.label === categoryValue) {
                    promptsValue.value = element.value;
                }
            });
        } 
       
       loading.close()
 
    }).catch(err => {
        loading.close()
        console.log(err);
    })



  }
  const getDataList = () => {
      state.loading.spinning = true
      // 将响应式query返回起原始对象
      let p = toRaw(state.query)
  
      checkListGetall(p).then(res => {
        state.loading.spinning = false
       
        let promptsList = []; 
        for(let item of res.data.result){
            promptsList.push({value:item.id,label:item.name});
        }
        promptsOptions.value = promptsList;
      }).catch(err => {
        state.loading.spinning = false
        console.log(err)
      })
  
    }
  const submitUpload = () => {
    console.log("begin to upload");
    
    if(promptsValue.value==""){
        ElMessage.error('请选择清单');
        return;
    }
    console.log(fileUp.value)
    console.log(fileName.value)
    if(!fileUp.value){
        ElMessage.error('请选择文件');
        return;
    }
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading', 
    })
    // if(llmValue.value==""){
    //     ElMessage.error('请选择模型');
    //     return;
    // }
    //upload.value!.submit()
    var data = new FormData();
    data.append("file", fileUp.value, fileName.value);
    data.append("promptId", promptsValue.value);
    data.append("llm", llmValue.value);
    fileUp.value="";
    fileName.value="";
    create(data).then(res => {
        console.log(res);
        if(!uploadsIds){
            uploadsIds = []
        }
        uploadsIds.push(res.data)
        dbUtils.set("UploadsIds", uploadsIds)
        fetchData();
       
        loading.close()
 
    }).catch(err => {
        loading.close()
        console.log(err);
    })
  }
    const startRefreshing = () => {
        getDataList(); // 初始化时先获取一次数据
        timer = setInterval(() => {
            fetchData(currentPage.value);
        }, 1000*60); // 每 60 秒刷新一次
        timer2 = setInterval(() => {
            get_progress()
        }, 1000*10); // 每 10 秒刷新一次
    };

    const stopRefreshing = () => {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
       
        if(timer2){
            clearInterval(timer2);
            timer2 = null;
        }
    };
    //getDataList();

    // 监听selectedValue的变化并更新localStorage
    watch(promptsValue, (newValue) => {
        localStorage.setItem('promptsValue', newValue);
    });
    watch(llmValue, (newValue) => {
        localStorage.setItem('llmValue', newValue);
    });
    // 当组件挂载时，尝试从localStorage读取保存的选择值
    onMounted(() => {
        const savedValue = localStorage.getItem('promptsValue');
        if (savedValue) {
            promptsValue.value = savedValue;
        }
        const savedTwoValue = localStorage.getItem('llmValue');
        if (savedTwoValue) {
            llmValue.value = savedTwoValue;
        }
        ifLogin();
        
        startRefreshing();
    });
    onBeforeUnmount(() => {
      stopRefreshing();
    });

  </script>